import { FilterField } from '@features/file-explorer/components/Toolbar/filterTypes'

export const getFilterFields = (t: (key: string) => string): FilterField[] => [
  {
    key: 'name',
    label: t('fileExplorer.sortFields.name'),
    type: 'text' as const
  },
  {
    key: 'type',
    label: t('fileExplorer.sortFields.type'),
    type: 'choice' as const,
    choices: [
      { value: 'folder', label: t('fileExplorer.filters.types.folder') },
      { value: 'document', label: t('fileExplorer.filters.types.document') }
    ]
  },
  {
    key: 'size',
    label: t('fileExplorer.sortFields.size'),
    type: 'size' as const
  },
  {
    key: 'created_at',
    label: t('fileExplorer.sortFields.created'),
    type: 'date' as const
  },
  {
    key: 'updated_at',
    label: t('fileExplorer.sortFields.modified'),
    type: 'date' as const
  },
  {
    key: 'owner_id',
    label: t('fileExplorer.table.owner'),
    type: 'user' as const
  }
]
